import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { LayoutContext } from '../components/LayoutProvider';
import { useLocation, Link } from 'react-router-dom';
import BankID from '../components/Bankid';

/**
 * BankID login page — the default /login route for regular users.
 * Users scanning a QR code wristband are redirected here.
 */
const BankIdLogin = () => {
	const { t } = useTranslation();
	const { setIsHeaderVisible, setIsFooterVisible } = React.useContext(LayoutContext);

	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);
	const pending_token = queryParams.get('pending_token');

	useEffect(() => {
		if (pending_token) {
			setIsHeaderVisible(false);
			setIsFooterVisible(false);
		}

		return () => {
			setIsHeaderVisible(true);
			setIsFooterVisible(true);
		};
	}, [pending_token, setIsHeaderVisible, setIsFooterVisible]);

	return (
		<div className="flex flex-col items-center justify-center w-full bg-gradient">
			<BankID />
			<div className="mt-8 flex items-center gap-3 w-full max-w-xs sm:max-w-sm px-2">
				<div className="flex-1 h-px bg-gray-300" />
				<span className="text-xs text-gray-400 uppercase tracking-wide">{t("or") || "eller"}</span>
				<div className="flex-1 h-px bg-gray-300" />
			</div>
			<Link
				to={pending_token ? `/admin?pending_token=${pending_token}` : "/admin"}
				className="mt-3 text-sm text-gray-500 hover:text-gray-700 transition flex items-center gap-1.5"
			>
				<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
				{t("admin_login_with_password")}
			</Link>
		</div>
	);
};

export default BankIdLogin;
